/* eslint-disable react/prop-types, react/destructuring-assignment */
import React from 'react'
import { Modal } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import states from '../states.json'

// Generic header for integration modals that has the action title, integration name, and selected employee
function GenericModalHeader(props) {
  const { state, headerTitleId, headerStyle, selectedEmployee, selectedEmployees, integrationName, actionData } = props

  return (
    <Modal.Header className="grey-bg-color-1" style={headerStyle} closeButton={state !== states.LOADING}>
      {/* Header title */}
      <Modal.Title className="mt-4">
        <FormattedMessage id={headerTitleId || 'MENU.ENGAGE'} />
      </Modal.Title>

      {/* Employee name/number display */}
      {/* eslint-disable no-nested-ternary */}
      {selectedEmployee && !selectedEmployees?.length ? (
        <p className="mt-2">
          {selectedEmployee?.firstName} {selectedEmployee?.lastName}
        </p>
      ) : actionData?.newEmployee ? (
        <p className="mt-2">
          {actionData?.newEmployee?.firstName} {actionData?.newEmployee?.lastName}
        </p>
      ) : selectedEmployees?.length <= 1 ? (
        <p className="mt-2">
          {selectedEmployees[0]?.firstName} {selectedEmployees[0]?.lastName}
        </p>
      ) : (
        selectedEmployees?.length && (
          <p className="mt-2">
            {`${selectedEmployees?.length} `}
            <span>
              <FormattedMessage id="ENGAGE.EMPLOYEES_SELECTED_3" />
            </span>
          </p>
        )
      )}
      {/* eslint-enable no-nested-ternary */}

      {/* Integration name display */}
      {integrationName && <p className="mt-2">{integrationName}</p>}
    </Modal.Header>
  )
}

export default GenericModalHeader
